import { Col, Container, Row } from "react-bootstrap";
import LoginForm from "../../component/userAuth/LoginForm";
import logo from "../../assets/image/dct_logo.png";
import img1 from "../../assets/image/dct_img1.png";
import img2 from "../../assets/image/dct_img2.png";
import { useEffect } from "react";
import Cookies from "js-cookie";

const LoginPage = () => {
  useEffect(() => {
    localStorage.removeItem("userAuthToken");
    localStorage.removeItem("userDetail");
    Cookies.remove("userAuthToken", { path: "/" });
  }, []);
  return (
    <Container fluid>
      <Row className="no-gutter">
        <Col md={6} className="bg-light">
          <div className="login d-flex flex-column align-items-center justify-content-center py-5">
            <img src={logo} className="img-fluid mb-3" width={"40%"} alt="DCTS Logo"></img>
            <Container>
              <Row>
                <Col lg={10} xl={7} className="mx-auto">
                  <h4 className="fw-bold text-center mb-4">WELCOME TO DCT</h4>
                  <LoginForm />
                </Col>
              </Row>
            </Container>
          </div>
        </Col>
        <Col md={6} className="d-none bg-blue d-md-flex justify-content-center flex-column loginContainer">
          <div className="pt-5 pb-5">
            <h3>100% SATISFACTION GUARANTEED</h3>
            <ul>
              <li>
                <span></span>Knowledgeable and Dedicated Customer Service
              </li>
              <li>
                <span></span>Experienced Account Management
              </li>
              <li>
                <span></span>Successful Vendor Consolidation Methods
              </li>
              <li>
                <span></span>99% Fill-Rate/ On-Time and Accurate Deliveries
              </li>
              <li>
                <span></span>Private-Branded Low-Cost Products
              </li>
              <li>
                <span></span>Quality Brand-Name Products
              </li>
              <li>
                <span></span>Minority-Owned &amp; Operated
              </li>
            </ul>
          </div>

          <div className="logoStacked text-center">
            <img src={img1} className="img-fluid ms-5" alt="DCTS 1"></img>
            <img src={img2} className="img-fluid ms-5" alt="DCTS 2"></img>
          </div>
          <p className="disclaimer text-center text-white mt-3" style={{ fontSize: 12 }}>
            1971- {new Date().getFullYear()} (c) Diversified Chemical Technologies, Inc. All Rights Reserved
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
